// /src/site/components/Footer.js
import React from 'react';
import { Box, Typography, Container } from '@mui/material';

function Footer() {
  return (
    <Box sx={{ bgcolor: '#333', color: 'white', py: 3, mt: 4 }}>
      <Container maxWidth="md" align="center">
        <Typography variant="body1">
          © {new Date().getFullYear()} Neehaw.com. All Rights Reserved
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer;
